import { useCallback, useEffect, useRef, useState } from 'react';
import { getItem } from './api';

/** Name + current price per item id via GET /api/items/{id}; cached, with a forced reload for after-approval. */
export default function useItemDetails(ids) {
  const [items, setItems] = useState({});
  const asked = useRef(new Set());
  const key = [...new Set(ids.filter(Boolean))].sort().join('|');

  const load = useCallback(async (list) => {
    const results = await Promise.all(list.map((id) => getItem(id).catch(() => null)));
    setItems((prev) => {
      const next = { ...prev };
      list.forEach((id, i) => { if (results[i]) next[id] = results[i]; });
      return next;
    });
    return results;
  }, []);

  useEffect(() => {
    const missing = key ? key.split('|').filter((id) => !asked.current.has(id)) : [];
    missing.forEach((id) => asked.current.add(id));
    if (missing.length) load(missing);
  }, [key, load]);

  return { items, reload: load };
}
